import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import type { QuotationForClient } from '~/api/quotations/types';
import type { IconName } from '~/components';

import { useApproveQuotationForClient } from '~/api/quotations';
import { Button, StatusCard, Text } from '~/components';
import { toast } from '~/utils/toast';

import { statusCardContentStyle } from './QuotationForClient.css';

type Props = {
  approvalKey: string;
  quotationForClient: QuotationForClient;
};

export const QuotationForClientStatusCard = ({ approvalKey, quotationForClient: { quotation, user } }: Props) => {
  const mutation = useApproveQuotationForClient(approvalKey);

  const { t } = useTranslation(['common', 'quotations']);

  return (
    <StatusCard
      icon={match(quotation.status)
        .returnType<IconName>()
        .with('Sent', () => 'Mail')
        .with('Expired', () => 'HourglassBottom')
        .with('Approved', () => 'Check')
        .with('Rejected', () => 'CloseSmall')
        .exhaustive()}
      title={t('quotations:clientAccept.card.title', { user: user.companyName })}
    >
      <div className={statusCardContentStyle}>
        <Text>
          {match(quotation.status)
            .with('Sent', () => t('quotations:clientAccept.card.description.accept', { user: user.companyName }))
            .with('Expired', () => t('quotations:clientAccept.card.description.expired'))
            .with('Approved', () => t('quotations:clientAccept.card.description.accepted'))
            .with('Rejected', () => t('quotations:clientAccept.card.description.declined'))
            .exhaustive()}
        </Text>

        {quotation.status === 'Sent' && (
          <Button
            icon="Check"
            loading={mutation.isPending}
            onClick={() => mutation.mutate(undefined, { onError: () => toast.danger({ description: t('common:error') }) })}
          >
            {t('quotations:clientAccept.card.button')}
          </Button>
        )}
      </div>
    </StatusCard>
  );
};
